module.exports = __webpack_public_path__ + "img/thumb_20.fb891666.jpg";